/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 6th 2022, 12:31:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { BillingSchedule } from "lib/schemas";
import Badge from "@mui/material/Badge";
import Chip, { ChipProps } from "@mui/material/Chip";
import SellIcon from "@mui/icons-material/Sell";
import { minBy } from "lodash";

type PricingChipButtonProps = Pick<BillingSchedule, "price_settings"> &
  Pick<ChipProps, "onClick" | "color" | "variant">;

export const PricingChipButton = ({ price_settings, onClick, color, variant }: PricingChipButtonProps) => {
  const chipLabel = price_settings.price_rules?.length
    ? isNaN(Number(minBy(price_settings.price_rules, "price").price))
      ? "Price rules Based on Equations"
      : `Starting From ${minBy(price_settings.price_rules, "price").price}`
    : price_settings?.price
    ? isNaN(Number(price_settings.price))
      ? "Price Based on Equation"
      : price_settings.price
    : "No Prices Set";

  const chipComponent = (
    <Chip onClick={onClick} color={color} variant={variant} icon={<SellIcon />} label={chipLabel} />
  );

  return price_settings.price_rules?.length ? (
    <Badge
      badgeContent={`${price_settings.price_rules.length} price ${
        price_settings.price_rules.length > 1 ? "rules" : "rule"
      }`}
      color="primary"
    >
      {chipComponent}
    </Badge>
  ) : (
    <>{chipComponent}</>
  );
};
